import { Action } from '@ngrx/store';

export enum EExcelConnectCurrentActions {
    SetCurrentConnector = '[Excel connector] Set selected connector',
    UploadExcelFile = '[Excel connector] Upload excel file',
    UploadExcelFileSuccess = '[Excel connector] Upload excel file success',
    UploadExcelFileError = '[Excel connector] Upload excel file error',
    GetDetailFromVersion = '[Excel connector] Get connector detail from version',
    GetDetailFromVersionSuccess = '[Excel connector] Get connector detail from version success',
    ResetDetailFromVersion = '[Excel connector] Reset connector detail from version',
    DownloadExcelFile = '[Excel connector] Download excel file',
    DownloadExcelFileSuccess = '[Excel connector] Download excel file success',
    SetSelectedFileName = '[Excel connector] Set selected file name',
}

export class SetCurrentConnector implements Action {
    public readonly type = EExcelConnectCurrentActions.SetCurrentConnector;
    constructor(public payload: IExcelConnector) { };
}

export class UploadExcelFile implements Action {
    public readonly type = EExcelConnectCurrentActions.UploadExcelFile;
    constructor(public payload: any) { };
}

export class UploadExcelFileSuccess implements Action {
    public readonly type = EExcelConnectCurrentActions.UploadExcelFileSuccess;
    constructor(public payload: any) { };
}

export class UploadExcelFileError implements Action {
    public readonly type = EExcelConnectCurrentActions.UploadExcelFileError;
    constructor() { };
}

export class GetDetailFromVersion implements Action {
    public readonly type = EExcelConnectCurrentActions.GetDetailFromVersion;
    constructor(public payload: string) { };
}

export class GetDetailFromVersionSuccess implements Action {
    public readonly type = EExcelConnectCurrentActions.GetDetailFromVersionSuccess;
    constructor(public payload: any) { };
}

export class ResetDetailFromVersion implements Action {
    public readonly type = EExcelConnectCurrentActions.ResetDetailFromVersion;
    constructor() { };
}

export class DownloadExcelFile implements Action {
    public readonly type = EExcelConnectCurrentActions.DownloadExcelFile;
    constructor(public payload: string) { };
}

export class DownloadExcelFileSuccess implements Action {
    public readonly type = EExcelConnectCurrentActions.DownloadExcelFileSuccess;
    constructor(public payload: any) { };
}

export class SetSelectedFileName implements Action {
    public readonly type = EExcelConnectCurrentActions.SetSelectedFileName;
    constructor(public payload: string) { };
}

export type ExcelConnectCurrentActions = UploadExcelFile |
    UploadExcelFileSuccess |
    SetCurrentConnector |
    GetDetailFromVersion |
    GetDetailFromVersionSuccess |
    ResetDetailFromVersion |
    DownloadExcelFile |
    DownloadExcelFileSuccess |
    SetSelectedFileName |
    UploadExcelFileError
    ;
